/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

const DocumentTypes = Object.freeze({
  MIPR: '4',
  '7600A': '11',
  '7600B': '42',
  GPC_FORM: '43',
  CUST_RESP: '47',
  ORDER_SUMMARY: '44',
  COMMUNICATION: '21',
  NOTE: '22',
  CHESS: '3'
});

export default DocumentTypes;
